module.exports = __webpack_public_path__ + "img/品牌赛事_3@2x.347fa05a.png";